import { useEffect, useState } from "react";
import { getStudentOrderHistory } from "../../services/dashboardService";
import Loading from "../../components/shared/Loading";
import { useSelector } from "react-redux";

const StudentHistory = () => {
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const token: string = useSelector((state: any) => state.auth.token);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const resData: any = await getStudentOrderHistory(token);

      setData(resData?.data);
      setIsLoading(false);
    };
    fetchData();
  }, [token]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="col-lg-9">
      <div className="dashboard__content-wrap">
        <div className="dashboard__content-title">
          <h4 className="title">Order History</h4>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="dashboard__review-table">
              <table className="table table-borderless">
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>Course Name</th>
                    <th>Date</th>
                    <th>Price</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {data &&
                    data.length > 0 &&
                    data.map((order: any, index: number) => (
                      <tr key={index}>
                        <td>
                          <p>{order?.orderId}</p>
                        </td>
                        <td>
                          <p>{order?.courseName}</p>
                        </td>
                        <td>
                          <p>{order?.date}</p>
                        </td>
                        <td>
                          <p>₹{order.amount}</p>
                        </td>
                        <td>
                          <span
                            className={`dashboard__quiz-result ${
                              order.statusClass || ""
                            }`}
                          >
                            {order?.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentHistory;
